<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.part" :value="rulePart" />
      <rule-game :title="ruleTitle.noBet" :value="ruleNobet" />
      <rule-game :title="ruleTitle.ruleBet" :value="ruleBet" />
      <rule-game :title="ruleTitle.ruleWinlose" :value="ruleWinlose" />
      <rule-game :title="ruleTitle.asset" :value="ruleAsset" />
      <rule-game :title="ruleTitle.payTable" :value="rulePaytable" />
      <rule-game :title="ruleTitle.point" :value="rulePoint" />
      <rule-game :title="ruleTitle.beadRoad" :value="ruleBeadroad" />
      <rule-game :title="ruleTitle.bigRoad" :value="ruleBigroad" />
      <rule-game :title="ruleTitle.bigEye" :value="ruleBigeye" />
    </div>
  </div>
</template>

<script>
import Dtbanner from '../../assets/gamerule/dt/Board_DT.png';
import Dtpart from '../../assets/gamerule/dt/TH.png';
import Dtpart2 from '../../assets/gamerule/dt/Component Under.png';
import Dtnobet from '../../assets/gamerule/dt/Free hand.png';
import Dtnobet2 from '../../assets/gamerule/dt/Skip.png';
import Dtbet1 from '../../assets/gamerule/dt/Bet 1.png';
import Dtbet2 from '../../assets/gamerule/dt/Bet 2.png';
import Dtwinlose1 from '../../assets/gamerule/dt/WinLose1.png';
import Dtwinlose2 from '../../assets/gamerule/dt/WinLose2.png';
import Dtasset from '../../assets/gamerule/dt/Asset 30.png';
import Dtasset2 from '../../assets/gamerule/dt/Asset 26.png';
import Dtcard from '../../assets/gamerule/dt/Order Card.png';
import Dtbead from '../../assets/gamerule/dt/Bead Road.png';
import Dtbig from '../../assets/gamerule/dt/Big Road.png';
import Dtbigeye from '../../assets/gamerule/dt/Big Eye Road.png';
import Fsrule from '../../assets/gamerule/fruitslot/fruit_text1.png';

export default {
  name: 'rule_dragontiger',
  data() {
    return {
      ruleHeader: {
        gameName: 'เสือมังกร (Dragon x Tiger)',
        boardImg: Dtbanner,
      },
      ruleTitle: {
        part: 'ส่วนประกอบ',
        noBet: 'รอบที่ไม่มีการเดิมพัน',
        ruleBet: 'วิธีการเดิมพัน',
        ruleWinlose: 'วิธีการดูผลแพ้ชนะ',
        asset: 'ประเภทเหรียญการเดิมพัน',
        payTable: 'อันตราการจ่าย',
        point: 'แต้มไพ่',
        beadRoad: 'ตาราง Bead Road',
        bigRoad: 'ตาราง Big Road',
        bigEye: 'ตาราง Big Eye Road',
      },
      ruleGame: [
        {
          image: Fsrule,
          type: 'imageNoborderSlot',
          class: 'w-30 ml-3',
        },
        {
          type: 'textDt',
          text: ' เกมส์เสือมังกรเป็นเกมส์ที่เล่นง่ายมาก เจ้ามือจะจั่วไพ่สำหรับมังกรและพยัคฆ์เพื่อแข่งขันแต้มกันไพ่จะมีตั้งแต่ A,2,3,4,5,6,7,8,9,10,J,Q และ K โดยที่ A มีค่าเท่ากับ 1 แต้ม และ K เท่ากับ 13 แต้ม ไม่นับไพ่สูทและไม่ใช้โจ๊คเกอร์ ในการเล่นแต้มที่มากกว่าระหว่างมือของ',
          textCol: ' มังกร ',
          text2: 'และ',
          textCol2: ' เสือ ',
          text3: 'จะเป็นผู้ชนะ เช่น Q ชนะ J',
        },
      ],
      rulePart: [
        {
          type: 'dtPart',
          image: Dtpart,
          image2: Dtpart2,
          text1: '1. ประเภทเหรียญในการเดิมพัน',
          text2: '2. ค่าเงินสูงสุดและต่ำสุดในการเดิมพันแต่ละรอบ',
          text3: '3. ประวัติการออกไพ่ในแต่ละรอบ',
          text4: '4. โต๊ะสำหรับวางเหรียญเดิมพัน',
          text5: '5. ค่าเงินเดิมพันทั้งหมดในแต่ละรอบ',
          text6: '6. ปุ่มสำหรับกดแต่ละประเภท',
          text7: '- ปุ่มเดิมพันซ้ำ ใช้สำหรับการเดิมพันประเภทเดิมซ้ำ',
          text8: '- ปุ่มยกเลิก ใช้สำหรับยกเลิกทั้งหมด',
          text9: '- ปุ่มตกลง ใช้สำหรับการยืนยันการเดิมพันทั้งหมด',
          text10: '7. ตารางสถิติ บันทึกประวัติการเล่น 50 รอบ',
          text11: '8. กราฟสรุปสถิติ รูปแบบทั้งหมด',
        },
      ],
      ruleNobet: [
        {
          type: 'twoImageText',
          image: Dtnobet,
          image2: Dtnobet2,
          text: 'ในกรณีเข้าเล่นเกมส์ครั้งแรก ประวัติการเล่นจะยังไม่มี ดังนั้นจึงอาจจะทำให้ผู้เล่นไม่สามารถรู้รูปแบบการออกในตาถัดไปได้ ตัวเกมส์จึงมีส่วนของการเล่นแบบไม่มีการเดิมพัน 5 รอบ เพื่อให้ผู้เล่นสามารถคาดการณ์รูปแบบที่จะออกในตาถัดไปได้ และมีการแสดงการเล่นจริงใน 5 รอบที่ไม่มีการเดิมพัน โดยผู้เล่นสามารถข้ามในส่วนนี้ได้โดยการกดปุ่ม ข้าม',
        },
      ],
      ruleBet: [
        {
          type: 'twoImageTextDt',
          image: Dtbet1,
          image2: Dtbet2,
          text: 'เมื่อเริ่มเกมส์ขึ้นมา ให้ทำการเดิมพันโดยเลือกเหรียญเดิมพันตามราคาที่ต้องการ โดยการเดิมพันจะแบ่งออกเป็น 3 ฝั่งหลักๆ ได้แก่',
          textCol: ' มังกร',
          text2: ',',
          textCol2: ' เสมอ',
          text3: ',',
          textCol3: ' เสือ',
          text4: ' ให้เลือกเดิมพัน เมื่อทำการเดิมพันเรียบร้อยแล้ว ให้ทำการกดปุ่มยืนยันเพื่อเริ่มการแจกไพ่',
        },
      ],
      ruleWinlose: [
        {
          type: 'twoImageTextDt2',
          image: Dtwinlose1,
          image2: Dtwinlose2,
          text: 'โดยวิธีการดูผลแพ้ชนะนั้น จะดูจากแต้มไพ่ของทั้งสองฝั่ง (',
          textCol: 'มังกร',
          text2: ',',
          textCol2: 'เสือ',
          text3: ') ว่าฝั่งไหนแต้มมากกว่ากัน ฝั่งที่แต้มมากกว่าคือผู้ชนะ หรือในกรณีที่ ',
          textCol3: 'เสมอ',
          text4: ' ผู้ที่ทำการเดิมพันฝั่ง',
          textCol4: ' มังกร ',
          text5: 'หรือ',
          textCol5: ' เสือ จะได้รับเงินคืนครึ่งหนึ่ง',
        },
      ],
      ruleAsset: [
        {
          type: 'imageTextCol',
          image: Dtasset,
          text: '*** หมายเหตุ ในการเดิมพันแต่ละรอบจะมี Limit ในการเดิมพันตั้งแต่ 5 - 2,000 THB ***',
        },
      ],
      rulePaytable: [
        {
          type: 'image',
          image: Dtasset2,
          class: 'w-70',
        },
      ],
      rulePoint: [
        {
          type: 'imageTextDt',
          classMain: 'mt-2',
          text: 'อันดับของไพ่จะนับจากต่ำสุดไปสูงสุด โดย เอช(A) จะมีค่าต่ำที่สุดและ คิง(K) จะมีค่ามากที่สุดดังนี้',
          text2: 'A < 2 < 3 < 4 < 5 < 6 < 7 < 8 < 9 < 10 < J < Q < K',
          image: Dtcard,
          text3: '*** ดอกของไพ่จะไม่มีผลต่อการคำนวณลำดับไพ่ ***',
        },
      ],
      ruleBeadroad: [
        {
          type: 'imageTextDt2',
          text: 'เป็นตารางที่เข้าใจง่ายและบันทึกง่ายที่สุด ในตารางจะมี 6 แถวแนวนอนไว้เพื่อเปรียบเทียบกัน วิธีการบันทึกคือ เริ่มต้นที่มุมซ้ายบน ถ้าเป็นฝั่งมังกรจะใส่สีน้ำเงิน ถ้าเป็นฝั่งเสือจะเป็นสีแดง เสมอจะเป็นสีเขียว บันทึกตามลำดับในแนวตั้ง',
          image: Dtbead,
          text2: 'สีน้ำเงิน ',
          text21: '= มังกรชนะ',
          text3: 'สีแดง ',
          text31: '= เสือชนะ',
          text4: 'สีเขียว ',
          text41: '= เสมอ',
        },
      ],
      ruleBigroad: [
        {
          type: 'imageTextDt3',
          image: Dtbig,
          class: 'w-70',
          text: 'ตารางใหญ่สุดหรือ Big Road คือช่องตารางการแสดงผลการชนะในแต่ละรอบ โดย',
          textCol: ' สีน้ำเงิน ',
          text2: 'หมายถึงฝั่งมังกรชนะ,',
          textCol2: ' สีแดง ',
          text3: 'หมายถึงเสือชนะ และ',
          textCol3: 'สีเขียว',
          text4: 'คลาดกลางจะหมายถึงเสมอ โดยจะมีการเปลี่ยนแถวใหม่ก็ต่อเมื่อมีการเปลี่ยนแปลงฝั่งชนะ',
        },
      ],
      ruleBigeye: [
        {
          type: 'imageTextDt4',
          image: Dtbigeye,
          class2: 'w-70',
          text1: 'สีน้ำเงิน',
          text11: ' = มีการเปลี่ยนแปลงรูปแบบ เกิดขึ้นบ่อยครั้ง',
          text2: 'สีแดง',
          text21: ' = มีการซ้ำรูปแบบเดิมๆ เกิดขึ้นเรื่อยๆ',
          text3: 'ตาราง Big Eye Road เป็นอีกหนี่งเทคนิคของนักพนันชาวจีน ที่ใช้เป็นเหมือนตัววัด เพื่อดูว่าผลลัพธ์ของฝั่งมังกร และฝั่งเสือ มีรูปแบบซ้ำในรูปแบบเดิมมากน้อยแค่ไหนในตอนนี้ โดยถ้า',
          textCol: ' สีแดง ',
          text4: 'ในตารางเยอะ แสดงว่ามีรูปแบบการเล่น ที่สมดุลระหว่างฝั่งมังกรกับฝั่งเสือ แต่ถ้ามี',
          textCol2: ' สีน้ำเงิน ',
          text5: 'เยอะในตาราง แสดงว่ามีรูปแบบที่วุ่นวาย ไม่มีรูปแบบที่แน่นอน',
        },
      ],
    };
  },
};
</script>
